<template>
  <div>
    <h1>研究成果</h1>
    <div v-for="work in works">
      <h3>{{ work.title }}年</h3>
      <ul class="object" name="work" v-html="work.text"></ul>
    </div>
  </div>
</template>

<script>


import {AxiosInstance as axios} from "axios";

export default {
  name: 'WorkView',
  data() {
    return {
      texts: ['2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013'],
      works: []
    }
  },
  props: {
    msg: String
  },
  methods: {
    adjustHeight(elm) {
      const h = elm.scrollHeight
      console.log(h)
      elm.innerHeight = h
    },
    async fetchWork(text) {
      const workfile = 'works/' + text + '.txt'

      await this.$axios.get(workfile).then(response => {
        var data = response.data
        data = data.replace(/\n/g, '</li><li>')
        data = '<li>' + data

        // TODO データの改行
        this.works.push({
          title: text,
          text: data
        })
      })
    }
  },
  mounted() {
    this.texts.forEach(text => {
      this.fetchWork(text)
    })
  }
}
</script>


<style scoped>
.object {
  width: 90%;
}

</style>
